
export default function ConfirmationModal({ visible, onClose }) {


    if (!visible) return null;
    const handleOnClose = () => {
        onClose();
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center">
            <div className=" p-2 m-4 rounded md:w-[30%] w-[98%] max-h-full mx-auto bg-gradient-to-t from-[#641662] to-pink-200">
                <button className="float-right mr-2" onClick={handleOnClose}>
                    X
                </button>
                <div className="columns flex space-x-52">
                    <div className="bg-icon w-[22%] h-12 bg-no-repeat bg-cover  ml-4 mt-4 pb-10"></div>
                </div>
                <div className="mb-10">
                    <h2 className="text-white mt-6 text-[16px] font-[600] text-center justify-center">
                        You have successfully invited a prospective partner
                    </h2>
                    <div className="mb-3  mt-7 w-full ml-10">
                        <button onClick={() => handleOnClose()} className="rounded-full  bg-[#CD64A3] w-[85%] font-[700] text-[12px] px-5 py-2    text-white transition duration-200  hover:bg-[#9c4c7c]">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
